export default "__VITE_ASSET__CEte8FLr__"